<template>
  <div
    v-if="label"
    :class="$style.label"
  >
    {{ label }}
  </div>
  <div
    v-else
    :class="$style.separator"
  />
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
}>();
</script>

<style module>
.separator {
  height: 1px;
  background-color: $black-8;
  margin: 8px 8px;
}

.label {
  margin: 8px 8px;
  font-size: 15px;
  line-height: 24px;
  color: var(--hf-color-text-secondary, rgba(5, 5, 5, 0.6));
  border-bottom: 1px solid $black-8;
}
</style>

<i18n lang="json">{}</i18n>
